import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import ProtectedRoute from './components/ProtectedRoute';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import RegisterSocio from './pages/RegisterSocio';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import Profile from './pages/Profile';
import PermissionManagement from './pages/PermissionManagement';
import Reports from './pages/Reports';
import ReporteSocioAdmin from './pages/ReporteSocioAdmin';
import Configuration from './pages/Configuration';
import SociosManagement from './pages/SociosManagement';
import ValoresManagement from './pages/ValoresManagement';
import ProgramaManagement from './pages/ProgramaManagement';
import MultasManagement from './pages/MultasManagement';
import ReportesValores from './pages/ReportesValores';
import ReporteGeneral from './pages/ReporteGeneral';
import AsistenciaManagement from './pages/AsistenciaManagement';
import AuditoriaManagement from './pages/AuditoriaManagement';
import PrestamosManagement from './pages/PrestamosManagement';
import LoanValueManagement from './pages/LoanValueManagement';
import SolicitudPrestamo from './pages/SolicitudPrestamo';
import SolicitudesPrestamosAdmin from './pages/SolicitudesPrestamosAdmin';
import PlantillaPrestamoManagement from './pages/PlantillaPrestamoManagement';
import ReporteSocio from './pages/ReporteSocio';
import PuntosReunion from './pages/PuntosReunion';
import LugaresReunion from './pages/LugaresReunion';
import InformeSecretaria from './pages/InformeSecretaria';
import SaludPrestamos from './pages/SaludPrestamos';
import InteresesCobrados from './pages/InteresesCobrados';
import ReporteDeudas from './pages/ReporteDeudas';

// Estilos
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <UserProvider>
        <Router>
          <div className="App">
            <Sidebar />
            <main className="main-content">
              <Routes>
                {/* Rutas públicas */}
                <Route path="/login" element={<Login />} />
                <Route path="/register-socio" element={<RegisterSocio />} />
                
                {/* Rutas protegidas */}
                <Route path="/dashboard" element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } />
                
                <Route path="/profile" element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } />
                
                <Route path="/users" element={
                  <ProtectedRoute adminOnly={true}>
                    <UserManagement />
                  </ProtectedRoute>
                } />
                
                <Route path="/permissions" element={
                  <ProtectedRoute superAdminOnly={true}>
                    <PermissionManagement />
                  </ProtectedRoute>
                } />
                
                <Route path="/reports" element={
                  <ProtectedRoute>
                    <Reports />
                  </ProtectedRoute>
                } />
                
                <Route path="/reportes/socio-admin" element={
                  <ProtectedRoute adminOnly={true}>
                    <ReporteSocioAdmin />
                  </ProtectedRoute>
                } />
                
                <Route path="/configuration" element={
                  <ProtectedRoute adminOnly={true}>
                    <Configuration />
                  </ProtectedRoute>
                } />
                
                <Route path="/socios" element={
                  <ProtectedRoute adminOnly={true}>
                    <SociosManagement />
                  </ProtectedRoute>
                } />
                
                <Route path="/socios/valores" element={
                  <ProtectedRoute adminOnly={true}>
                    <ValoresManagement />
                  </ProtectedRoute>
                } />

                <Route path="/socios/programa" element={
                  <ProtectedRoute adminOnly={true}>
                    <ProgramaManagement />
                  </ProtectedRoute>
                } />

                <Route path="/socios/multas" element={
                  <ProtectedRoute adminOnly={true}>
                    <MultasManagement />
                  </ProtectedRoute>
                } />

                <Route path="/reportes/valores" element={
                  <ProtectedRoute adminOnly={true}>
                    <ReportesValores />
                  </ProtectedRoute>
                } />
                
                <Route path="/reportes/general" element={
                  <ProtectedRoute adminOnly={true}>
                    <ReporteGeneral />
                  </ProtectedRoute>
                } />
                
                <Route path="/asistencia" element={
                  <ProtectedRoute>
                    <AsistenciaManagement />
                  </ProtectedRoute>
                } />
                
                <Route path="/auditoria" element={
                  <ProtectedRoute superAdminOnly={true}>
                    <AuditoriaManagement />
                  </ProtectedRoute>
                } />

                <Route path="/reportes/deudas" element={
                  <ProtectedRoute adminOnly={true}>
                    <ReporteDeudas />
                  </ProtectedRoute>
                } />

                <Route path="/reportes/intereses" element={
                  <ProtectedRoute adminOnly={true}>
                    <InteresesCobrados />
                  </ProtectedRoute>
                } />

                <Route path="/salud-prestamos" element={
                  <ProtectedRoute adminOnly={true}>
                    <SaludPrestamos />
                  </ProtectedRoute>
                } />

                <Route path="/solicitudes/prestamos" element={
                  <ProtectedRoute>
                    <SolicitudPrestamo />
                  </ProtectedRoute>
                } />
                
                <Route path="/plantilla-prestamo" element={
                  <ProtectedRoute adminOnly={true}>
                    <PlantillaPrestamoManagement />
                  </ProtectedRoute>
                } />
                
                <Route path="/solicitudes/socios" element={
                  <ProtectedRoute adminOnly={true}>
                    <SolicitudesPrestamosAdmin />
                  </ProtectedRoute>
                } />
                
                <Route path="/loan-values" element={<ProtectedRoute><LoanValueManagement /></ProtectedRoute>} />
                <Route path="/solicitudes-prestamos-admin" element={
                  <ProtectedRoute adminOnly={true}>
                    <SolicitudesPrestamosAdmin />
                  </ProtectedRoute>
                } />
                
                <Route path="/mis-solicitudes" element={
                  <ProtectedRoute>
                    <SolicitudPrestamo />
                  </ProtectedRoute>
                } />
                
                <Route path="/reportes/socio" element={
                  <ProtectedRoute>
                    <ReporteSocio />
                  </ProtectedRoute>
                } />
                
                <Route path="/puntos-reunion" element={
                  <ProtectedRoute>
                    <PuntosReunion />
                  </ProtectedRoute>
                } />
                
                <Route path="/informe-secretaria" element={
                  <ProtectedRoute>
                    <InformeSecretaria />
                  </ProtectedRoute>
                } />
                
                <Route path="/lugares-reunion" element={
                  <ProtectedRoute>
                    <LugaresReunion />
                  </ProtectedRoute>
                } />
                
                {/* Redirección por defecto */}
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </main>
            
            {/* Toast notifications */}
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </div>
        </Router>
      </UserProvider>
    </AuthProvider>
  );
}

export default App;